import styled from 'styled-components';
import { Stack } from '@appcues/sonar';

export const DomainStack = styled(Stack).attrs({
  spacing: 'x-small',
})`
  margin-bottom: var(--spacing-large, 24px);
`;
